interface NetworkCallStats {
	totalOperations: number;
}

class FrontendNetworkTracker {
	private stats: NetworkCallStats = {
		totalOperations: 0,
	};

	// Called from createWrappedFetch for each individual operation
	trackGraphQLOperations(operationNames: string[]) {
		// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
		if (process.env.REACT_SSR || typeof window === 'undefined') {
			return;
		}

		operationNames.forEach(() => {
			this.stats.totalOperations++;
		});
	}

	// Called from cfetch for REST calls
	trackRestCall(_url?: string) {
		// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
		if (process.env.REACT_SSR || typeof window === 'undefined') {
			return;
		}

		this.stats.totalOperations++;
	}

	getStats(): NetworkCallStats {
		return { ...this.stats };
	}

	reset() {
		this.stats = {
			totalOperations: 0,
		};
	}
}

// Export singleton instance
export const networkTracker = new FrontendNetworkTracker();
export type { NetworkCallStats };
